import PropTypes from "prop-types";
import { useCallback } from "react";

import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";

import FnrButton from "UI/FnrButton3";

import { parseButtonFunc } from "Utilities/parseButtonFunc";

import { buttonFuncConfig } from "./buttonFuncConfig";

export default function CTA({ buttonText, buttonFunc, backgroundColor }) {
  const { state } = usePaymentPage();
  const { paymentParent } = state;
  const { fundColorSafe } = state.fund;
  const [funcKey, param] = parseButtonFunc(buttonFunc);

  const handleClick = useCallback(() => {
    if (buttonFuncConfig[funcKey]) return buttonFuncConfig[funcKey](param);
    return () =>
      console.log(`${funcKey} is not a function in buttonFuncConfig`);
  }, [funcKey, param]);

  return (
    <FnrButton
      fullWidth
      size="large"
      color={
        backgroundColor
          ? backgroundColor
          : paymentParent?.themeColor || fundColorSafe
      }
      onClick={handleClick}
      data-cy="give-cta-button"
    >
      {buttonText}
    </FnrButton>
  );
}

CTA.propTypes = {
  buttonText: PropTypes.string.isRequired,
  buttonFunc: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
};
